import { render, staticRenderFns } from "./ResponsibilitiesPickerV2.vue?vue&type=template&id=4d369918&scoped=true"
import script from "./ResponsibilitiesPickerV2.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesPickerV2.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilitiesPickerV2.vue?vue&type=style&index=0&id=4d369918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d369918",
  null
  
)

export default component.exports